import { render, staticRenderFns } from "./LinkRichText.vue?vue&type=template&id=5e7ec2c9&"
import script from "./LinkRichText.vue?vue&type=script&lang=js&"
export * from "./LinkRichText.vue?vue&type=script&lang=js&"
import style0 from "./LinkRichText.vue?vue&type=style&index=0&id=5e7ec2c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports